module.exports = __webpack_public_path__ + "media/customizations/woodforest/back-13c3342ea10d76aa2aa3c50cf9486c14.jpg";